import { render, staticRenderFns } from "./TheAvatar.vue?vue&type=template&id=16430ef2&scoped=true&"
import script from "./TheAvatar.vue?vue&type=script&lang=js&"
export * from "./TheAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TheAvatar.vue?vue&type=style&index=0&id=16430ef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16430ef2",
  null
  
)

export default component.exports